/**
 * NOTE: Manual embedded AdSense units have been removed in favour of Google Auto Ads.
 * This component now renders nothing while preserving existing imports.
 */

import React from 'react';

const EmbeddedAdSense: React.FC<{ postId?: number; className?: string; style?: React.CSSProperties }> = () => null;

export default EmbeddedAdSense; 